/** 判断内容是否为空 */
export function isEmptyString(str) {
  if (typeof str !== "string") return true;
  if (str.length === 0) return true;
  let spaceNum = 0;
  for (let i = 0; i < str.length; i++) {
    if (str[i] === " ") {
      spaceNum++;
    }
  }

  return spaceNum === str.length;
}